export const ENTITY_TYPE_OPTIONS = [
  { value: "PRIVATE_LIMITED", label: "Private Limited" },
  { value: "LIMITED", label: "Limited" },
  { value: "PROPRIETORSHIP", label: "Proprietorship" },
  { value: "OTHER", label: "Other" },
];

/** Matches sa_be UpdateSupplierInvitationByToken validation. */
/** Matches c_be SupplierEmployeeSizeCategory enum. */
export const EMPLOYEE_SIZE_OPTIONS = [
  "1-10",
  "1-50",
  "51-100",
  "101-500",
  "501-1000",
  "1000+",
];

export const COUNTRY_OPTIONS = [
  { value: "IN", label: "India" },
  { value: "US", label: "United States" },
  { value: "GB", label: "United Kingdom" },
  { value: "SG", label: "Singapore" },
  { value: "AE", label: "United Arab Emirates" },
];

export const EMPTY_PERCENT_ROW = () => ({ name: "", percentage: "" });

export const EMPTY_EMPLOYEE_COUNTS = () => ({
  male: "",
  female: "",
  others: "",
});

export const INITIAL_ACCEPT_SUPPLIER_FORM = {
  first_name: "",
  last_name: "",
  email: "",
  mobile: "",
  password: "",
  confirm_password: "",
  country: "IN",
  entity_type: "PRIVATE_LIMITED",
  cin: "",
  gstin: "",
  pan: "",
  company_name: "",
  address1: "",
  address2: "",
  city: "",
  state: "",
  zip_code: "",
  employee_size_category: "51-100",
  business_activities: [
    { name: "Manufacturing", percentage: "70" },
    { name: "Trading", percentage: "30" },
  ],
  products_or_services: [{ name: "Products / services", percentage: "100" }],
  manufacturing_plants: { national: "", international: "" },
  offices: { national: "", international: "" },
  permanent_employees: { male: "", female: "", others: "" },
  non_permanent_employees: { male: "", female: "", others: "" },
};
